export default {
    computed: {
        getPorcentajeAlicuota() {
            return alicuota => {
                let alicuotas = {3: 0, 4: 10.5, 5: 21, 6: 27, 8: 5}
                return alicuotas[alicuota]
            }

        }
    }
}
